import { LogOut } from "lucide-react";
 import { useNavigate } from "react-router";
import { useApiAccess, useAuth } from "@repo/hooks/contexts";
import { useLogout } from "@repo/hooks/queries";
 
export function Logout() {
  const { setUserPrincipal } = useAuth();
  const { setAccessToken } = useApiAccess();
  const { mutate: logout } = useLogout();
  const navigate = useNavigate();

  const logoutUser = () => {
    logout();

    setUserPrincipal(null);
    setAccessToken(null);

    navigate("login", { replace: true });
  };

  return (
    <button
      onClick={logoutUser}
      className="flex items-center text-sm gap-3 px-2 py-1 mt-3 text-gray-700 rounded-lg group hover:cursor-pointer hover:bg-gray-100 hover:text-gray-700"
    >
      <LogOut size={20} className="stroke-gray-500" />
      Sign out
    </button>
  );
}

